import React from "react";
import { Link } from "wouter";

import { ActionLink } from "../../../styles";
import { AttentionActionLinkProps } from "./types";

export const AttentionActionLink: React.FC<AttentionActionLinkProps> = ({
  action: { label, href },
}) => (
  <Link href={href} asChild>
    <ActionLink>{label}</ActionLink>
  </Link>
);
